import React, { useState } from 'react';
import { Layout, Avatar, Button, Drawer, Menu } from 'antd';
import { UserOutlined, LogoutOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { auth } from '../firebase/config';
import { signOut } from 'firebase/auth';

const { Header } = Layout;

const Navbar = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setSidebarVisible(false);
      setMobileMenuVisible(false);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const menuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: 'Home',
      onClick: () => {
        navigate('/');
        setSidebarVisible(false);
      },
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
      onClick: handleLogout,
    },
  ];

  return (
    <Header style={{ 
      background: '#fff', 
      padding: '0 24px', 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      position: 'fixed',
      width: '100%',
      zIndex: 1000,
    }}>
      {/* Logo */}
      <div 
        style={{ 
          fontSize: '24px', 
          fontWeight: 'bold', 
          cursor: 'pointer',
          color: '#1890ff',
        }}
        onClick={() => navigate('/')}
      >
        VoteTracker
      </div>

      {/* Desktop Profile Icon */}
      <div>
        <Avatar
          style={{ 
            backgroundColor: '#1890ff',
            cursor: 'pointer',
          }}
          icon={<UserOutlined />}
          onClick={() => setSidebarVisible(true)}
        />
      </div>

      {/* Sidebar */}
      <Drawer
        title="Profile"
        placement="right"
        onClose={() => setSidebarVisible(false)}
        open={sidebarVisible}
        width={280}
      >
        <div style={{ marginBottom: '24px', padding: '16px', background: '#f5f5f5', borderRadius: '8px' }}>
          <div style={{ color: '#666', marginBottom: '4px' }}>Signed in as</div>
          <div style={{ fontWeight: '500' }}>{currentUser?.email}</div>
        </div>
        <Menu
          mode="inline"
          items={menuItems}
          style={{ border: 'none' }}
        />
      </Drawer>
    </Header>
  );
};

export default Navbar;